// ============================================================================
// PortalAcademia.jsx — Passo 45 MC4
// Página do Portal para a Academia RDA (Painel do Aluno)
// ============================================================================
import React from 'react';
import PortalPageHeader from '../../components/portal/PortalPageHeader';
import { StudentAcademyView } from '../../components/portal/StudentAcademyView';

export default function PortalAcademia() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <PortalPageHeader
        title="Academia RDA"
        subtitle="Cursos jurídicos exclusivos para clientes do escritório."
      />
      <div className="flex flex-col items-center justify-center flex-1 min-h-0">
        <p className="text-2xl font-extrabold text-[#20243B] uppercase tracking-widest">Em breve</p>
        <p className="text-sm text-gray-400 mt-2">Estamos preparando conteúdos exclusivos para você.</p>
      </div>
    </div>
  );
}
